import {
    GetTeamList,
    DeleteTeam,
    ChangeTeamStatus,
    PostTeam,
    GetTeam,
    UpdateTeam,
} from '@src/services/team'
import { getSavedState } from '@src/utils/localStorage'
export const state = {
    teamList: [],
    profilesList: [],
}

export const getters = {
    totalList(state) {
        return state.teamList.data ? state.teamList.data.list.totalItemCount : 0
    },
    maxTeam(state) {
        return state.teamList.data ? state.teamList.data.max : 0
    },
    currentTeam(state) {
        return state.teamList.data ? state.teamList.data.current : 0
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.teamList = newList
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((team) => {
            state.teamList.data.list.items.push(team)
        })
    },
    SET_STATUS(state, team) {
        state.teamList.data.list.items.find(({ publicId }) => {
            return publicId === team.publicId
        }).status = team.status
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetTeamList(locationPublicId, parameters)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async nextPage({ commit }, currentPage) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetTeamList(locationPublicId, currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.list.items)
        }
    },
    async deleteTeam({ dispatch }, team) {
        const resp = await DeleteTeam(team)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async setStatus({ commit }, parameters) {
        const resp = await ChangeTeamStatus(parameters)
        if (resp.status === 200) {
            commit('SET_STATUS', parameters)
        }
        return resp
    },
    async createTeam({ _ }, teamMember) {
        teamMember.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await PostTeam(teamMember)
        return resp
    },
    async setTeamForm({ _ }, team) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetTeam(team, locationPublicId)
        return resp
    },
    async updateTeam({ _ }, team) {
        team.locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await UpdateTeam(team)
        return resp
    },
    async changeTeamStatus({ _ }, team) {
        team.locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await ChangeTeamStatus(team)
        return resp
    },
}